import * as Factory from 'factory.ts'
import faker from 'faker'

import { AccountMock } from './account.factory'
import { CurrencyMock } from './currency.factory'
import { type CostAllocation } from '../../models'

export const CostAllocationMock = Factory.Sync.makeFactory<CostAllocation>({
  id: Factory.each(() => faker.random.number()),
  budget: Factory.each(() => AccountMock.build()),
  amount: Factory.each(() => faker.random.number().toString()),
  created_on: Factory.each(() => faker.date.past().toISOString()),
  currency: CurrencyMock.build(),
  object_id: Factory.each(() => faker.random.number()),
})
